import { FC } from 'react';
import { IconButton, Tooltip } from '@lambdacurry/component-library';

export interface EditRatingButtonProps {
  onClick: () => void;
}

export const EditRatingButton: FC<EditRatingButtonProps> = ({ onClick }) => (
  <Tooltip title="Edit Rating">
    <IconButton data-cy="edit-rating" icon="pencil" onClick={onClick} />
  </Tooltip>
);
